import React from 'react';

import styles from '../../styles/match-widget.module.scss';
import classnames from "classnames";
import {LoadingIndicator} from "../../../../core/components/loading/loading-indicator";

export const MatchWidgetPlaceholder = () => {
  return (
   <div className={classnames(styles.placeholder_container)}>
     <LoadingIndicator />
   </div>
  )
};
